import type { Campaign } from './campaigns';

export interface CreatorProfile {
  id: string;
  username: string;
  displayName: string;
  bio: string;
  avatar: string;
  coverImage: string;
  location: string;
  joinedDate: string;
  isVerified: boolean;
  category: string;
  socialLinks: {
    twitter?: string;
    instagram?: string;
    youtube?: string;
    snapchat?: string;
    website?: string;
  };
  stats: {
    totalRaised: number;
    totalDonors: number;
    campaignsCount: number;
    successRate: number;
  };
  badges: string[];
  campaignIds: string[];
}

export const creatorProfiles: CreatorProfile[] = [
  {
    id: 'ahmed-shamri',
    username: 'ahmed_shamri',
    displayName: 'أحمد الشمري',
    bio: 'مطور تطبيقات ومبدع تقني من الرياض. أؤمن بأن التكنولوجيا يمكنها تغيير حياة أطفالنا للأفضل. أعمل على بناء تطبيقات تعليمية تراعي القيم العربية والإسلامية.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Saudi%20man%20portrait%20clean%20background%20warm%20lighting%20confident%20smile&width=200&height=200&seq=301&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=modern%20tech%20workspace%20Saudi%20Arabia%20laptop%20code%20programming%20minimalist%20clean%20desk%20warm%20tones&width=1200&height=400&seq=401&orientation=landscape',
    location: 'الرياض، المملكة العربية السعودية',
    joinedDate: 'يناير 2024',
    isVerified: true,
    category: 'تقنية وتعليم',
    socialLinks: {
      twitter: 'ahmed_shamri',
      instagram: 'ahmed.shamri',
      youtube: 'AhmedShamri',
      website: 'ahmedshamri.sa',
    },
    stats: {
      totalRaised: 32500,
      totalDonors: 248,
      campaignsCount: 2,
      successRate: 87,
    },
    badges: ['مبدع موثق', 'داعم المجتمع', 'مشروع ناجح'],
    campaignIds: ['1'],
  },
  {
    id: 'sara-qahtani',
    username: 'sara_qahtani',
    displayName: 'سارة القحطاني',
    bio: 'رائدة أعمال شابة وعاشقة للقهوة والكتب. أحلم بإنشاء مساحة ثقافية تجمع المبدعين والمثقفين في قلب الرياض. أؤمن أن الثقافة هي أساس التقدم.',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20Saudi%20woman%20portrait%20clean%20background%20warm%20lighting%20hijab%20elegant%20smile&width=200&height=200&seq=302&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=cozy%20coffee%20shop%20interior%20warm%20lighting%20books%20elegant%20Arabic%20ambiance%20Saudi%20Arabia&width=1200&height=400&seq=402&orientation=landscape',
    location: 'الرياض، المملكة العربية السعودية',
    joinedDate: 'مارس 2024',
    isVerified: true,
    category: 'ريادة أعمال',
    socialLinks: {
      twitter: 'sara_qahtani',
      instagram: 'sara.qahtani',
      snapchat: 'sara_q',
    },
    stats: {
      totalRaised: 41200,
      totalDonors: 312,
      campaignsCount: 1,
      successRate: 92,
    },
    badges: ['مبدعة موثقة', 'رائدة أعمال', 'نجمة الشهر'],
    campaignIds: ['2'],
  },
  {
    id: 'mohammed-otaibi',
    username: 'mohammed_otaibi',
    displayName: 'محمد العتيبي',
    bio: 'صانع محتوى ومقدم بودكاست من الدمام. أروي قصص نجاح رواد الأعمال العرب وأُلهم الشباب لتحقيق أحلامهم. بودكاست "حكايا عربية" وصل لأكثر من 100,000 مستمع.',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Saudi%20man%20content%20creator%20portrait%20clean%20background%20casual%20confident%20warm&width=200&height=200&seq=303&orientation=squarish',
    coverImage: 'https://readdy.ai/api/search-image?query=podcast%20studio%20microphone%20professional%20recording%20setup%20modern%20warm%20lighting%20creative%20space&width=1200&height=400&seq=403&orientation=landscape',
    location: 'الدمام، المملكة العربية السعودية',
    joinedDate: 'فبراير 2024',
    isVerified: true,
    category: 'محتوى رقمي',
    socialLinks: {
      twitter: 'mo_otaibi',
      instagram: 'mohammed.otaibi',
      youtube: 'HikayaArabia',
      snapchat: 'mo_otaibi',
    },
    stats: {
      totalRaised: 22800,
      totalDonors: 567,
      campaignsCount: 3,
      successRate: 95,
    },
    badges: ['صانع محتوى', 'الأكثر دعماً', 'مبدع موثق'],
    campaignIds: ['3'],
  },
];

export const getProfileByUsername = (username: string): CreatorProfile | undefined =>
  creatorProfiles.find((p) => p.username === username);

export const getProfileById = (id: string): CreatorProfile | undefined =>
  creatorProfiles.find((p) => p.id === id);
